export class OrderByData {
  constructor(
    public readonly fieldPath: string,
    public readonly direction?: "desc" | "asc"
  ) {}
}
